import styled, {css} from 'styled-components'
import Button from 'components/Button'

export const Card = styled.div`
  border: 2px solid #d94e4e;
  border-radius: 6px;
  background: #00000080;
  min-height: 520px;

  @media screen and (min-width: 310px) {
    width: 100%;
    max-width: 310px;
    min-height: 540px;
  }
  @media screen and (min-width: 375px) {
    width: 100%;
    max-width: none;
  }
  @media screen and (max-width: 1200px) {
    margin-top: 20px;
  }
`

export const CardHeader = styled.div`
  font-size: 24px;
  line-height: 60px;
  border-bottom: 2px solid #d94e4e;
`

export const DetailArea = styled.div`
  background: #ffffff20;
  border-radius: 6px;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #ffffff60;
`
export const StakeCard = styled.div`
  padding: 10px;
  overflow-y: auto;
  // scrollbar-width: none;
  display: flex;
  flex-wrap: wrap;
  min-height: 240px;
  max-height: 240px;
  justify-content: center;
  cursor: pointer;
  ::-webkit-scrollbar {
    display: none; /* For Webkit-based browsers */
  }
  scrollbar-width: none;
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
`
export const StakeTitle = styled.div`
  padding: 10px;
`

export const DetailedCard = styled.div`
  padding: 10px;
`

export const DetailTitle = styled.div`
  opacity: 0.6;
  font-size: 12px;
`
export const DetailHeader = styled.div`
  opacity: 0.6;
  font-size: 12px;
`
export const DetailValue = styled.div`
  font-size: 14px;
`

export const ImageArea = styled.div`
  margin: 20px 0;
`

export const CrossLine = styled.div`
  width: 100%;
  height: 2px;
  background: #d94e4e;
  margin-top: -80px;
  margin-bottom: 75px;
`

export const ActionArea = styled.div`
  margin: 10px 0px;
  padding-top: 10px;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export const ControlContent = styled.div`
  font-size: 26px;
  font-weight: 700;
  margin: 0 15px;
`

export const ControlButton = styled.button<{ disable?: boolean }>`
  background: transparent;
  outline: none;
  color: ${({ disabled }) => (disabled ? '#FFFFFF80' : 'white')};
  font-size: 24px;
  font-weight: 700;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`

export const ActionButton = styled(Button)`
  min-width: 80px;
  max-width: 130px;
  height: 36px;
  border-radius: 100px;
  margin-left: 5px;
  margin-top: 30px;
  background-color: #d94e4e;
`
export const LotteryButton = styled(Button)`
  min-width: 210px;
  height: 36px;
  border-radius: 100px;
  margin-top: 10px;
`

export const ActionSecondaryButton = styled(Button)`
  min-width: 130px;
  max-width: 130px;
  height: 36px;
  border-radius: 100px;
  background: transparent;
  border: 2px solid #4099ff;
`

export const Descriptions = styled.div`
  min-height: 60px;
  justify-content: left;
`

export const Description = styled.div`
  text-align: left;
  font-size: 14px;
  margin: 0 10px;
  color: #ffffff80;
`
